<div class="login-component" [ngClass]="mode">
  <p id="logindesc" aria-live="assertive" style="display: none;">
    {{ 'login.linkYourSmartTV' | translate}}.
    1. {{ 'login.scanYourQR' | translate: { value: qrTTSLink  }  }}.
    2. {{ 'login.enterTheCodeBelow' | translate }}.
    {{ qrTTSCode }}
  </p>
  <div class="login-options">
    <div class="option">
      <div class="text">
        <h1 class="sign-in-subtitle" aria-labelledby="logindesc" aria-live="assertive">
          {{ 'login.scanWithTheApp' | translate }}
        </h1>
        <p class="sign-in-text">{{ 'login.linkYourSmartTV' | translate}}</p>
        <ol>
          <li class="sign-in-text">{{ 'login.scanYourQR' | translate: { value: qrLink  }  }}</li>
          <li class="sign-in-text">{{ 'login.enterTheCodeBelow' | translate }}</li>
        </ol>
        <!-- ENTER THE CODE -->
        <span class="sign-in-code">
          {{ activationCode }}
        </span>
      </div>
      <!-- QR CODE TO THE RIGHT -->
      <div class="qr-code-css">
        <ngx-kjua [text]="qrLinkComplete"></ngx-kjua>
      </div>
    </div>
  </div>
</div>
